export default "__VITE_ASSET__e3e2ce0a__"